module.exports = __webpack_public_path__ + "uK9sO6mmf5L0OqWIh/warning.svg";